<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation @onValidate="submit" novalidate v-av-analytics-form-submit="{ elementText: btnText }">
      <h2 class="mb-3 mb-sm-4">{{ $t('message.eCommerceV2.finance.rentOrOwnForm.heading') }}</h2>
      <mobialis-selection-input-with-validation
        rules="required"
        :label="$t('message.eCommerceV2.finance.rentOrOwnForm.homeOwnershipType')"
        v-model="homeOwnershipType"
        :placeHolder="$t('message.credit.application.chooseOwnershipType')"
        vid="homeOwnershipType"
        :options="ownership"
        data-cy="homeOwnershipType"
      ></mobialis-selection-input-with-validation>
      <mobialis-text-input-with-validation
        rules="required|max:25"
        :label="$t('message.credit.application.askMortgageCompany')"
        v-model="mortgageCompany"
        vid="mortgageCompany"
        :helper="$t('message.credit.application.askMortgageCompanyHelper')"
        data-cy="mortgageCompany"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        rules="required|decimal:2|max_value:9999"
        :label="$t('message.eCommerceV2.finance.rentOrOwnForm.monthlyPayment')"
        :helper="$t('message.eCommerceV2.finance.rentOrOwnForm.monthlyPaymentHelper')"
        v-model="monthlyPayment"
        vid="monthlyPayment"
        :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'money'"
        inputmode="decimal"
        data-cy="monthlyPayment"
      ></mobialis-text-input-with-validation>
      <!--  if contact info is complete that means this is the last page in finance flow -->
      <mobialis-check-box-with-validation
        v-if="creditComplete"
        class="mt-4 pt-2"
        rules="required:true"
        :label="
          $t('message.eCommerceV2.finance.tandc', {
            termsLink: $t('message.eCommerceV2.finance.termsLink'),
            dealerName: businessName,
          })
        "
        vid="tandc"
        id="tandc"
        data-cy="tAndC"
        v-model="tandc"
      >
      </mobialis-check-box-with-validation>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{ btnText }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';
import { homeOwnershipMixin } from '@/mixins';

export default {
  name: 'RentOrOwnForm',
  mixins: [homeOwnershipMixin],
  data() {
    return {
      homeOwnershipType: cloneDeep(this.$store.state.user.financeApplication.ownershipType),
      mortgageCompany: cloneDeep(this.$store.state.user.financeApplication.mortgageCompany),
      monthlyPayment: cloneDeep(this.$store.state.user.financeDetails.monthlyPayment),
      tandc: false,
    };
  },
  computed: {
    ...mapGetters({
      businessName: 'business/getBusinessName',
    }),
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    btnText() {
      return this.creditComplete
        ? this.$t('message.eCommerceV2.finance.submitApplication')
        : this.$t('message.common.continue');
    },
  },
  methods: {
    async submitFinanceApplication() {
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createFinanceApplication');
      } catch (err) {
        this.$log('Error creating finance application:', err);
        this.$router.push({ path: `${this.getProductBasePath()}/error` });
        throw err;
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
    async submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('user/SET_OWNERSHIP_TYPE', this.homeOwnershipType);
      this.$store.commit('user/SET_MORTGAGE_COMPANY', this.mortgageCompany);
      this.$store.commit('user/SET_MONTHLY_PAYMENT', this.monthlyPayment);
      if (this.creditComplete) {
        try {
          await this.submitFinanceApplication();
        } catch (err) {
          return;
        }
      }
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
